export default __webpack_public_path__ + "static/media/construcciones.e6420e13.svg";